const CirclePlus = (
    <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
    >
        <path d="m9 16.25c4.0041 0 7.25-3.2459 7.25-7.25 0-4.00406-3.2459-7.25-7.25-7.25-4.00406 0-7.25 3.24594-7.25 7.25 0 4.0041 3.24594 7.25 7.25 7.25z" />
        <path d="m5.75 9h6.5" />
        <path d="m9 5.75v6.5" />
    </g>
);

export { CirclePlus };
